<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-if="icon"
            icon
            v-bind="attrs"
            v-on="on"
        >
          <v-icon style="color: #f32121">
            mdi-delete
          </v-icon>
        </v-btn>
        <v-btn
            v-else-if="block"
            v-bind="attrs"
            block
            v-on="on"
            class="error"
        >
          <v-icon small>
            mdi-delete
          </v-icon>
          删除
        </v-btn>
        <v-btn
            v-else
            v-bind="attrs"
            v-on="on"
            class="error"
        >
          <v-icon>
            mdi-delete
          </v-icon>
          删除
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          注意！
        </v-card-title>

        <v-card-text>
          你确定删除吗？<br>此操作无法撤回！
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              @click="deleteMethod"
          >
            删除
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="dialog = false"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DeleteBtn",
  data() {
    return {
      dialog: false
    }
  },
  props: {
    icon: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    deleteMethod() {
      this.$emit("confirm")
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
